import { useState, useEffect, useCallback } from 'react';
import pushNotificationService from '@/services/pushNotifications';

export function usePushNotifications() {
  const [permission, setPermission] = useState('default');
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    setSupported(pushNotificationService.isSupported());
    setPermission(pushNotificationService.getPermission());
  }, []);

  const requestPermission = useCallback(async () => {
    const result = await pushNotificationService.requestPermission();
    setPermission(result);
    return result;
  }, []);

  const sendNotification = useCallback(async (title, options) => {
    return pushNotificationService.sendNotification(title, options);
  }, []);

  const sendPolicyAlert = useCallback(async (policy, language) => {
    return pushNotificationService.sendPolicyAlert(policy, language);
  }, []);

  const sendAlert = useCallback(async (alert, language) => {
    return pushNotificationService.sendAlert(alert, language);
  }, []);

  return {
    permission,
    supported,
    isGranted: permission === 'granted',
    isDenied: permission === 'denied',
    requestPermission,
    sendNotification,
    sendPolicyAlert,
    sendAlert,
  };
}

export default usePushNotifications;
